import { FC, useEffect } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import { Loader } from "@/components";
import { SignUpAnonymouslyUrl } from "@/features/auth/components/SignUpAnonymouslyUrl";

/**
 * PrecisionGamePS5Signup component.
 *
 * This component handles the signup process for the Precision Game PS5 raffle.
 * It checks if the user profile exists and navigates to the PS5 raffle page if the user is logged in.
 * If no profile is found, it renders a signup component for anonymous users.
 * While navigation is in progress, a loader is displayed.
 *
 * @returns {JSX.Element} The rendered component, which can be a signup form, a loader, or navigation logic.
 */
const PrecisionGamePS5Signup: FC = (): JSX.Element => {
  const profile = useCurrentUserProfile((s) => s.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (profile && profile.uid) {
      navigate(siteRoutes["PSRaffle"]);
    }
  }, [profile, navigate]);

  // If no profile, show signup component
  if (!profile) {
    return <SignUpAnonymouslyUrl />;
  }

  // Show loader while navigation is happening (if profile exists)
  return <Loader />;
};

export default PrecisionGamePS5Signup;
